export enum HTTPStatusCode {
  Success = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Conflict = 409,
  TooManyRequest = 429,
}

export enum ReportLanguage {
  English = 'en-HK',
  SimplifiedChinese = 'zh-Hans-HK',
  TraditionalChinese = 'zh-Hant-HK',
}

export enum Type {
  EMAIL = 'email',
}

export enum Partner {
  'TASSCARE' = 'tasscare',
  'ARTMED' = 'artmed',
  'OGATH' = 'ogath',
  'BDMSTH' = 'bdmsth',
  'CIRCLE' = 'circle', // this will be changed to b2b
}

export enum EmailTagName {
  b2bpartner = 'b2bpartner',
  b2bcustomer = 'b2bcustomer',
  tag = 'b2bcustomer-email',
}

export enum Ethnicity {
  african = 'african',
  caucasian = 'caucasian',
  eastasian = 'eastasian',
  eastasiansoutheastasian = 'eastasiansoutheastasian',
  hispanic = 'hispanic',
  middleeastern = 'middleeastern',
  nativeamerican = 'nativeamerican',
  other = 'other',
  pacificislander = 'pacificislander',
  southeastasian = 'southeastasian',
  southasian = 'southasian',
}

export enum Gender {
  male = 'male',
  female = 'female',
}

export enum CountryCode {
  tw = '+886',
  hk = '+852',
  vi = '+84',
  in = '+62',
  th = '+66',
}
export enum PhoneType {
  MOBILE = 'mobile',
}

export const GENDER: Record<Gender, string> = {
  [Gender.male]: 'Male',
  [Gender.female]: 'Female',
};

export const COUNTRY: Record<CountryCode, string> = {
  [CountryCode.tw]: '+886',
  [CountryCode.hk]: '+852',
  [CountryCode.vi]: '+84',
  [CountryCode.in]: '+62',
  [CountryCode.th]: '+66',
};
export const ETHNICITY: Record<Ethnicity, string> = {
  [Ethnicity.african]: 'African',
  [Ethnicity.caucasian]: 'Caucasian',
  [Ethnicity.eastasiansoutheastasian]: 'East Asian/Southeast Asian',
  [Ethnicity.hispanic]: 'Hispanic',
  [Ethnicity.middleeastern]: 'Middle Eastern',
  [Ethnicity.nativeamerican]: 'Native American',
  [Ethnicity.other]: 'Other',
  [Ethnicity.pacificislander]: 'Pacific Islander',
  [Ethnicity.southasian]: 'South Asian',
  [Ethnicity.eastasian]: 'Eastasian',
  [Ethnicity.southeastasian]: 'South East Asian',
};

export const getEthnicityByPartner = (partner: Partner) => {
  if (partner === Partner.CIRCLE) {
    const clonedEthnicity = JSON.parse(JSON.stringify(ETHNICITY));
    delete clonedEthnicity.eastasian;
    delete clonedEthnicity.southeastasian;
    return clonedEthnicity;
  } else {
    return ETHNICITY;
  }
};

export const getPartnerPhoneNumber = (partner: Partner) => {
  if (partner === Partner.TASSCARE) {
    const clonedNumber = JSON.parse(JSON.stringify(COUNTRY));
    delete clonedNumber[CountryCode.tw];
    return clonedNumber;
  }
  return COUNTRY;
};
export interface APIError {
  status: HTTPStatusCode;
  data: { error_code: string, error_message: string };
}

export interface ErrorResponse {
  response: APIError;
}

export interface Token {
  token: string;
}

export interface CustomerId {
  customerId: string;
}

export interface ProfileId {
  profileId: string;
}

export interface UserId {
  userId: string;
}

export interface BaseModel {
  error?: APIError;
}

export interface KitProgress {
  activatedDate: string;
  sampleReceivedDate: string;
  reportReadyDate: string;
}

export interface ButtonStye {
  textColor: string;
  backgroundColor: string;
  isFullwidth?: boolean;
}